import Api from './Api'

const instance = Api.instance

export default instance
